(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-custom"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('main-product-custom')) {
  customElements.define('main-product-custom', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.ready = false;
      this.busy = false;
      this.uncertain = false;
      this.mix = false;
      this.index = 0;
      this.boot();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      clearInterval(this.clockTimer);
      this.observer?.disconnect();
      this.purchaseObserver?.disconnect();
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
    }
    on(target, name, handler, options = {}) {
      target?.addEventListener(name, handler, {...options, signal: this.abort.signal});
    }
    async boot() {
      const node = this.querySelector('[data-config]');
      if (!node) return;
      try {
        this.config = JSON.parse(node.textContent);
        this.form = this.querySelector('.mpc__native-buy form');
        this.nativeForm = this.form?.closest('product-form');
        this.submit = this.form?.querySelector('[name=add]');
        if (this.submit) this.submit.dataset.submit = '';
        this.fields = [...this.querySelectorAll('[data-option-position]')];
        this.options = [...this.config.initialOptions];
        this.moneyFormat = new Intl.NumberFormat(this.config.locale || 'en', {style:'currency', currency:this.config.currency || 'USD', currencyDisplay:this.config.currencyCode ? 'code' : 'symbol'});
        this.gallery();
        if (this.querySelector('model-viewer') && window.Shopify?.loadFeatures) {
          window.Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0',onLoad:errors => {
            if (!errors && this.isConnected && window.Shopify.ModelViewerUI) this.querySelectorAll('model-viewer').forEach(model => new window.Shopify.ModelViewerUI(model));
          }}]);
        }
        this.dialogs();
        this.countdown();
        if (this.submit) {
          this.purchaseObserver = new MutationObserver(() => {
            const loading = this.submit.classList.contains('loading');
            if (loading !== this.nativeBusy) {
              this.nativeBusy = loading;
              this.fields.forEach(field => field.querySelectorAll('input').forEach(input => {input.disabled = loading;}));
            }
          });
          this.purchaseObserver.observe(this.submit, {attributes:true,attributeFilter:['class']});
        }
        window.Shopify?.PaymentButton?.init?.();
        this.on(this, 'change', event => this.change(event));
        this.on(this, 'click', event => {
          if (event.target.matches('input[type=radio]') && event.target.closest('[data-option-position]')) {
            queueMicrotask(() => {if (this.isConnected && this.ready) this.syncVariantMedia(true);});
          }
        });
        this.on(document, 'shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          const id = event.detail?.blockId;
          const index = this.slides.findIndex(slide => slide.dataset.blockId === id);
          if (index >= 0) this.go(index);
        });
        let page = JSON.parse(this.querySelector('[data-variants]').textContent);
        const variants = new Map(page.variants.map(v => [String(v.id), v]));
        const seen = new Set();
        if (page.page > 1) {
          const url = new URL(this.config.renderUrl || location.pathname, location.origin);
          url.searchParams.set(page.pageParam, '1');
          page.next = url.href;
        }
        while (page.next) {
          const url = new URL(page.next, location.origin);
          if (url.origin !== location.origin || seen.has(url.href)) throw new Error(this.config.text.error);
          seen.add(url.href);
          url.searchParams.set('section_id', this.config.sectionId);
          const response = await fetch(url, {signal:this.abort.signal, credentials:'same-origin'});
          if (!response.ok) throw new Error(this.config.text.error);
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const data = html.querySelector('[data-variants]');
          if (!data) throw new Error(this.config.text.error);
          page = JSON.parse(data.textContent);
          page.variants.forEach(v => variants.set(String(v.id), v));
        }
        if (!this.isConnected) return;
        this.variants = [...variants.values()];
        this.ready = true;
        this.classList.add('is-ready');
        const selected = this.variants.find(v => String(v.id) === this.form?.querySelector('[name="id"]')?.value);
        if (selected) this.options = [...selected.options];
        this.refresh();
        this.on(this.form, 'change', () => this.readNativeVariant());
      } catch (error) {
        if (error.name !== 'AbortError') this.error(this.config?.text.error || 'Unable to load product options. Please refresh.');
      }
    }
    money(value) {return this.moneyFormat.format(value / 100);}
    variantFor() {
      return this.variants.find(v => v.options.length === this.options.length && v.options.every((value,index) => value === this.options[index]));
    }
    readNativeVariant() {
      if (!this.ready) return;
      const id = this.form?.querySelector('[name="id"]')?.value;
      const variant = this.variants.find(v => String(v.id) === id);
      if (variant) {this.options = [...variant.options];this.refresh();}
    }
    change(event) {
      const field = event.target.closest('[data-option-position]');
      if (!this.ready || this.nativeBusy || !field || !event.target.matches('input[type=radio]')) return;
      this.options[Number(field.dataset.optionPosition) - 1] = event.target.value;
      const variant = this.variantFor();
      if (variant && this.form) {
        const input = this.form.querySelector('[name="id"]');
        if (input) {input.value = String(variant.id);input.dispatchEvent(new Event('change',{bubbles:true}));}
        if (this.submit) {
          this.submit.disabled = !variant.available;
          const label = this.submit.querySelector('.main-atc__label__line-1 > span:not([class])');
          if (label) label.textContent = variant.available ? this.querySelector('[data-button-label]').dataset.buttonLabel : this.config.text.soldOut;
          if (variant.available) this.submit.removeAttribute('aria-disabled');
        }
      }
      this.refresh();
    }
    refresh() {
      if (!this.ready) return;
      const variant = this.variantFor();
      this.currentVariant = variant;
      this.fields.forEach(field => {
        const position = Number(field.dataset.optionPosition) - 1;
        field.querySelectorAll('input').forEach(input => {
          input.checked = input.value === this.options[position];
          const match = [...this.options];match[position] = input.value;
          const exists = this.variants.find(v => v.available && v.options.every((value,i) => value === match[i]));
          input.disabled = !exists || Boolean(this.nativeBusy);
          input.closest('label').classList.toggle('is-unavailable',!exists);
        });
      });
      this.querySelectorAll('.mpc__price [data-total]').forEach(el => {el.textContent = variant ? this.money(variant.price) : this.config.text.unavailable;});
      this.querySelectorAll('.mpc__price [data-compare]').forEach(el => {el.hidden = !variant || variant.compare <= variant.price;el.textContent = this.money(variant?.compare || 0);});
      this.querySelectorAll('[data-stock]').forEach(el => {
        const show = variant?.available && variant.managed && variant.policy !== 'continue' && variant.inventory > 0 && variant.inventory <= Number(el.dataset.threshold);
        el.hidden = !show;
        if (show) el.querySelector('[data-stock-text]').textContent = el.dataset.template.replace('{quantity}',String(variant.inventory));
        const progress = el.querySelector('[data-stock-progress]');
        const initial = Number(el.dataset.initialStock);
        progress.hidden = !show || initial <= 0 || variant.inventory > initial;
        if (!progress.hidden) {
          const percent = Math.floor((initial - variant.inventory) / initial * 100);
          progress.querySelector('progress').value = percent;
          progress.querySelector('[data-sold-percent]').textContent = `${percent}% ${el.dataset.soldLabel}`;
        }
      });
      if (!variant) return;
      this.syncVariantMedia();
      if (this.config.updateUrl && this.lastUrlId !== variant.id && !window.Shopify?.designMode) {
        const url = new URL(location.href);url.searchParams.set('variant',variant.id);url.searchParams.delete('option_values');
        history.replaceState(history.state,'',url);this.lastUrlId = variant.id;
      }
    }
    syncVariantMedia(force = false) {
      const variant = this.variantFor();
      if (!variant) return;
      let index = this.slides.findIndex(slide => {
        const value = slide.dataset.matchValue?.trim();
        const position = Number(slide.dataset.matchPosition) || this.config.colorPosition;
        return value && variant.options[position - 1]?.trim().toLowerCase() === value.toLowerCase();
      });
      const findMedia = v => this.slides.findIndex(slide =>
        (v?.mediaId && slide.dataset.mediaId === String(v.mediaId)) ||
        (v?.imageId && slide.dataset.imageId === String(v.imageId))
      );
      if (index < 0) index = findMedia(variant);
      if (index < 0 && this.config.colorPosition) {
        const color = variant.options[this.config.colorPosition - 1];
        for (const sibling of this.variants) {
          if (sibling.options[this.config.colorPosition - 1] !== color) continue;
          index = findMedia(sibling);
          if (index >= 0) break;
        }
      }
      if (index >= 0 && (force || this.lastLinkedVariant !== variant.id || this.lastLinkedIndex !== index)) this.go(index,force);
      this.lastLinkedVariant = variant.id;
      this.lastLinkedIndex = index;
    }
    gallery() {
      this.track = this.querySelector('[data-track]');
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      const dots = this.querySelector('[data-dots]');
      dots.replaceChildren();
      this.slides.forEach((slide, index) => {
        const dot = document.createElement('button');dot.type = 'button';dot.className = 'mpc__dot';
        dot.setAttribute('aria-label', `${this.querySelector('.mpc__gallery').getAttribute('aria-label')} ${index + 1}`);
        this.on(dot, 'click', () => this.go(index));dots.append(dot);
        this.on(this.thumbs[index], 'click', () => this.go(index));
      });
      this.dots = [...dots.children];
      this.on(this.querySelector('[data-prev]'), 'click', () => this.go((this.index - 1 + this.slides.length) % this.slides.length));
      this.on(this.querySelector('[data-next]'), 'click', () => this.go((this.index + 1) % this.slides.length));
      this.on(this.track, 'keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();this.go(Math.max(0,Math.min(this.slides.length - 1,this.index + (event.key === 'ArrowRight' ? 1 : -1))));}
      });
      this.on(this.track, 'scroll', () => {
        const width = this.track.clientWidth;
        if (width) this.mark(Math.round(Math.abs(this.track.scrollLeft) / width));
      }, {passive:true});
      this.querySelectorAll('[data-prev],[data-next],[data-dots]').forEach(el => {el.hidden = this.slides.length <= 1;});
      this.observer = new ResizeObserver(() => this.go(this.index, false));this.observer.observe(this.track);
      this.mark(0);
    }
    go(index, smooth = true) {
      if (!this.slides[index]) return;
      this.mark(index);
      this.track.scrollTo({left:this.track.clientWidth * index * (getComputedStyle(this.track).direction === 'rtl' ? -1 : 1), behavior:smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'});
    }
    mark(index) {
      this.index = index;
      this.thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current',String(i === index)));
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current',String(i === index)));
      const thumb = this.thumbs[index];
      if (thumb && thumb.parentElement.scrollWidth > thumb.parentElement.clientWidth) {
        thumb.parentElement.scrollLeft = thumb.offsetLeft - thumb.parentElement.offsetLeft - thumb.parentElement.clientWidth / 2 + thumb.clientWidth / 2;
      }
      this.slides.forEach((slide, i) => {
        if (i !== index) slide.querySelectorAll('video').forEach(video => video.pause());
      });
    }
    dialogs() {
      this.on(this, 'click', event => {
        const zoom = event.target.closest('[data-zoom]');
        if (zoom && this.config.zoom) {
          const image = this.querySelector('[data-large-image]');image.src = zoom.dataset.zoom;image.alt = zoom.querySelector('img')?.alt || '';
          this.querySelector('[data-lightbox]').showModal();
        }
        if (event.target.closest('[data-open-guide]')) this.querySelector('[data-guide]')?.showModal();
        if (event.target.closest('[data-close]')) event.target.closest('dialog')?.close();
        if (event.target.matches('dialog')) {
          const rect = event.target.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
        }
      });
    }
    countdown() {
      const blocks = [...this.querySelectorAll('[data-countdown]')];
      if (!blocks.length) return;
      const tick = () => blocks.forEach(block => {
        const date = block.dataset.deadline;
        const deadline = /^\d{4}-\d{2}-\d{2}T.*(?:Z|[+-]\d{2}:\d{2})$/.test(date) ? Date.parse(date) : NaN;
        const seconds = Math.ceil((deadline - Date.now()) / 1000);
        block.hidden = !Number.isFinite(seconds) || seconds <= 0;
        if (!block.hidden) {
          const hours = Math.floor(seconds / 3600);
          block.querySelector('[data-clock]').textContent = `${String(hours).padStart(2,'0')}:${String(Math.floor(seconds % 3600 / 60)).padStart(2,'0')}:${String(seconds % 60).padStart(2,'0')}`;
        }
      });
      tick();this.clockTimer = setInterval(tick,1000);
    }
    error(message) {
      const el = this.querySelector('[data-error]');if (!el) return;
      el.textContent = message;el.hidden = !message;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-video-reel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ugc-upload-reel')) {
    customElements.define('ugc-upload-reel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const on = (node, name, handler, options = {}) => node.addEventListener(name, handler, { ...options, signal:this.controller.signal });
        this.viewport = this.querySelector('.upload-reel__viewport');
        this.track = this.querySelector('.upload-reel__track');
        this.group = this.querySelector('[data-original]');
        this.dialog = this.querySelector('dialog');
        this.player = this.querySelector('.upload-reel__player');
        this.motion = this.querySelector('.upload-reel__motion');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.enabled = this.dataset.auto === 'true';
        this.position = this.viewport.scrollLeft;
        this.visible = true;
        this.hovered = false;
        this.drag = null;
        this.userPaused = false;
        this.editorPaused = false;
        this.focused = false;
        this.lastTime = 0;
        this.resumeAt = 0;
        this.suppressUntil = 0;
        this.rebuild();
        this.resizeObserver = new ResizeObserver(() => this.rebuild());
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.group);
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          if (!this.visible) this.player.querySelector('video')?.pause();
        });
        this.visibilityObserver.observe(this);
        on(this.reduced, 'change', () => this.rebuild());
        on(this.viewport, 'pointerenter', (event) => { if (event.pointerType === 'mouse') this.hovered = true; });
        on(this.viewport, 'pointerleave', () => { this.hovered = false; });
        on(this.viewport, 'focusin', () => { this.focused = true; });
        on(this.viewport, 'focusout', (event) => { this.focused = this.viewport.contains(event.relatedTarget); });
        on(this.viewport, 'wheel', () => { this.resumeAt = performance.now() + 1800; }, {passive:true});
        on(this.viewport, 'pointerdown', (event) => {
          this.resumeAt = performance.now() + 1800;
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          this.drag = {x:event.clientX, start:this.viewport.scrollLeft, moved:false, id:event.pointerId};
        });
        on(window, 'pointermove', (event) => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          const delta = event.clientX - this.drag.x;
          if (Math.abs(delta) > 5) this.drag.moved = true;
          if (this.drag.moved) {
            event.preventDefault();
            this.viewport.scrollLeft = this.drag.start - delta;
            this.position = this.viewport.scrollLeft;
          }
        });
        const release = () => {
          if (this.drag?.moved) this.suppressUntil = performance.now() + 300;
          this.drag = null;
          this.position = this.viewport.scrollLeft;
          this.resumeAt = performance.now() + 1800;
        };
        on(window, 'pointerup', release);
        on(window, 'pointercancel', release);
        on(this.viewport, 'dragstart', (event) => event.preventDefault());
        on(this.viewport, 'click', (event) => {
          const button = event.target.closest('.upload-reel__open');
          if (!button || button.disabled || performance.now() < this.suppressUntil) return;
          const key = button.closest('[data-key]').dataset.key;
          const template = Array.from(this.querySelectorAll('template[data-video-key]')).find((item) => item.dataset.videoKey === key);
          if (!template) return;
          document.querySelectorAll('ugc-upload-reel dialog[open]').forEach((dialog) => dialog.close());
          this.opener = button;
          this.player.replaceChildren(template.content.cloneNode(true));
          this.dialog.showModal();
          const video = this.player.querySelector('video');
          video.play().catch(() => {});
        });
        on(this.querySelector('.upload-reel__close'), 'click', () => this.dialog.close());
        on(this.dialog, 'click', (event) => {
          const box = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) this.dialog.close();
        });
        on(this.dialog, 'close', () => {
          this.stopVideo();
          this.opener?.focus({preventScroll:true});
        });
        if (this.motion) on(this.motion, 'click', () => {
          this.userPaused = !this.userPaused;
          this.motion.setAttribute('aria-pressed', String(this.userPaused));
          this.motion.textContent = this.userPaused ? '▶' : 'Ⅱ';
        });
        on(this, 'shopify:block:select', (event) => {
          this.editorPaused = true;
          const card = event.target.closest('.upload-reel__card');
          if (card) this.viewport.scrollLeft = card.offsetLeft - this.group.offsetLeft;
        });
        on(this, 'shopify:block:deselect', () => { this.editorPaused = false; });
        this.frame = requestAnimationFrame((time) => this.tick(time));
      }
      rebuild() {
        this.track.querySelectorAll('[data-clone]').forEach((node) => node.remove());
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        this.span = this.group.getBoundingClientRect().width + gap;
        const repeat = this.enabled && !this.reduced.matches && this.group.children.length > 1 && this.span > 0;
        this.looping = repeat;
        if (repeat) {
          const copies = Math.ceil(this.viewport.clientWidth / this.span) + 1;
          for (let index = 0; index < copies; index++) {
            const clone = this.group.cloneNode(true);
            clone.removeAttribute('data-original');
            clone.setAttribute('data-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('button').forEach((button) => button.tabIndex = -1);
            clone.querySelectorAll('[data-shopify-editor-block]').forEach((node) => node.removeAttribute('data-shopify-editor-block'));
            this.track.append(clone);
          }
        }
        if (this.motion) this.motion.hidden = !repeat;
        this.position = this.viewport.scrollLeft;
      }
      tick(time) {
        const elapsed = this.lastTime ? Math.min(time - this.lastTime, 50) : 0;
        this.lastTime = time;
        const paused = this.userPaused || this.hovered || this.focused || this.drag || this.dialog.open || this.editorPaused || document.hidden || !this.visible || time < this.resumeAt;
        if (this.looping && !paused) {
          if (Math.abs(this.viewport.scrollLeft - this.position) > 1) this.position = this.viewport.scrollLeft;
          this.position = (this.position + Number(this.dataset.speed || 24) * elapsed / 1000) % this.span;
          this.viewport.scrollLeft = this.position;
        } else {
          this.position = this.viewport.scrollLeft;
        }
        this.frame = requestAnimationFrame((next) => this.tick(next));
      }
      stopVideo() {
        const video = this.player?.querySelector('video');
        if (video) { video.pause(); video.removeAttribute('src'); video.querySelectorAll('source').forEach((source) => source.removeAttribute('src')); video.load(); }
        this.player?.replaceChildren();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.controller?.abort();
        this.stopVideo();
        if (this.dialog?.open) this.dialog.close();
        this.track?.querySelectorAll('[data-clone]').forEach((node) => node.remove());
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
